package gr.tech.contactpage.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.layer.SilkLayer
import com.varabyte.kobweb.silk.style.layer.add
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import gr.tech.contactpage.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.DisplayStyle.Companion.Flex
import kotlin.math.min

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("html") {
        Modifier
            .scrollBehavior(ScrollBehavior.Smooth)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.cssRem)
    }

    // Silk dividers only extend 90% by default; we want full width dividers in our site
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth()
    }
}

fun Modifier.noBorder(): Modifier {
    return this
        .border (
            width = 0.px,
            style = LineStyle.None,
            color = Colors.Transparent
        )
        .outline(
            width = 0.px,
            style = LineStyle.None,
            color = Colors.Transparent
        )
}

fun Modifier.cappedWidth(): Modifier {
    return this.width(min(700.px, 100.percent - 1.cssRem))
}

fun baseInputModifier() = Modifier
    .fillMaxWidth()
    .height(34.px)
    .padding(4.px)
    .fontFamily(FONT_FAMILY)
    .color(Colors.Black)
    .outline(
        width = 2.px,
        style = LineStyle.Solid,
        color = Colors.Transparent
    )
    .transition(Transition.all(100.ms))


val InputStyle = CssStyle {
    base {
        baseInputModifier()
    }
    focus {
        Modifier
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.DarkGreen.rgb
            )
    }
}

val roomUseResponsiveStyle = CssStyle {
    base {
        Modifier
            .padding(2.px)
    }
    Breakpoint.MD {
        Modifier
            .height(110.px)
    }
}

val InputStyleHalf = CssStyle {
    base {
        baseInputModifier()
    }
    Breakpoint.MD {
        baseInputModifier()
            .fillMaxWidth(50.percent)
    }
    focus {
        Modifier
            .border(
            width = 2.px,
            style = LineStyle.Solid,
            color = Theme.DarkGreen.rgb
        )
    }

}

val InputColumn = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
    }
}

val InputColumnHalf = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
    }
    Breakpoint.MD {
        Modifier
            .fillMaxWidth(50.percent)
    }
}

val ContactRow = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(
                topBottom = 8.px,
            )
            .gap(16.px)
    }
}

val ResponsiveColumns = CssStyle {
    base {
        Modifier
            .display(Flex)
            .flexDirection(FlexDirection.Column)
    }
    Breakpoint.MD {
        Modifier
            .flexDirection(FlexDirection.Row)
    }
}

val SubmitButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Theme.DarkGreen.rgb)
            .noBorder()
            .borderRadius(5.px)
            .padding(
                topBottom = 16.px,
                leftRight = 16.px
            )
            .color(Colors.White)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.15.cssRem)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .scale(.96)
    }
}